import { reactive } from 'vue';

export const notificationStore = reactive({
  total: 0,
  lastPosNotification: {},
  totalCentral: 0,
});
